/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Course_Selectversiondescription2Inputs */

const zh_course_selectversiondescription2 = /** @type {(inputs: Course_Selectversiondescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择一个已有的学习资源关联到此节点`)
};

const en_course_selectversiondescription2 = /** @type {(inputs: Course_Selectversiondescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose an existing study resource to link to this node`)
};

const es_course_selectversiondescription2 = /** @type {(inputs: Course_Selectversiondescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige un recurso de estudio existente para vincular a este nodo`)
};

/**
* | output |
* | --- |
* | "Choose an existing study resource to link to this node" |
*
* @param {Course_Selectversiondescription2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const course_selectversiondescription2 = /** @type {((inputs?: Course_Selectversiondescription2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Course_Selectversiondescription2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_course_selectversiondescription2(inputs)
	if (locale === "en") return en_course_selectversiondescription2(inputs)
	return es_course_selectversiondescription2(inputs)
});
export { course_selectversiondescription2 as "course_selectVersionDescription" }